// app/components/Disc/DiscPopover.jsx
export default function DiscPopover(props) {
  const name = props?.name || '';
  const a = props?.assessedSpecificCount;
  const t = props?.totalSpecificCount;
  // Optional, default off (console keeps its current popover untouched): hides
  // the "N/M assessed" ratio on Area/Competency rings, keeping it only on the
  // outer Skill ring.
  const hideCount = props?.compactInnerRings && props?.depth !== 3;

  // Which ring the hovered slice belongs to — the class disc's popover says
  // this and the student disc's should too.
  const levelLabel = { 1: 'Area', 2: 'Competency', 3: 'Skill' }[props?.depth] || '';

  return (
    <div className="ds max-w-[260px] rounded-lg border border-border bg-popover px-2.5 py-2 text-popover-foreground shadow-xl">
      {levelLabel && (
        <div className="mb-1 text-[10px] font-semibold uppercase tracking-wide text-muted-foreground">
          {levelLabel}
        </div>
      )}
      <div className="flex flex-wrap items-center gap-1.5">
        <span className="rounded-md bg-secondary px-1.5 py-0.5 text-xs font-semibold text-foreground">
          {name}
        </span>
        {!hideCount && typeof a === 'number' && typeof t === 'number' && (
          <span className="rounded-md bg-primary/10 px-1.5 py-0.5 text-[11px] font-medium text-primary">
            {a}/{t} assessed
          </span>
        )}
      </div>
      <div className="mt-1 text-[11px] text-muted-foreground">
        {props?.depth === 3 ? 'Click to view skill developmental descriptors' : 'Click to zoom in'}
      </div>
    </div>
  );
}
